import React from "react";

import { Flex, Spinner } from "@chakra-ui/react";

import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { CompanyTypes } from "@/jenesys-types/jenesys-entities/config";

import {
  selectCompanies,
  selectIsBootstrapping
} from "@/store/app/bootstrap/bootstrap";
import { selectActiveCompanyId } from "@/store/features/companies/companies";

export const RootIndexRoute: React.FC = () => {
  const isAppBootstrapping = useSelector(selectIsBootstrapping);
  const selectedCompanyId = useSelector(selectActiveCompanyId);
  const companies = useSelector(selectCompanies);

  const redirectEntityId = selectedCompanyId || companies[0]?.id;

  if (isAppBootstrapping) {
    return (
      <Flex
        w="100vw"
        h="100vh"
        flexFlow="row nowrap"
        justifyContent="center"
        alignItems="center"
      >
        <Spinner size="xl" data-testid="spinner" />
      </Flex>
    );
  }

  if (redirectEntityId) {
    // Check if this ID belongs to a client or a company
    const entity = companies.find((c) => c.id === redirectEntityId);

    if (entity?.type === CompanyTypes.PRACTICE) {
      // If it's a practice entity, use company route- all practices should be on the user entity
      // So this should always exist and be a company route
      return <Navigate replace to={`/company/${redirectEntityId}`} />;
    }
    // If it's a client entity, redirect to client route
    // As we can have multiple clients on a practice, this wont be on a user entity, we can assume we're correct here
    return <Navigate replace to={`/client/${redirectEntityId}`} />;
  }

  return null;
};
